import MButton from '@assets/mui/@material-extend/MButton';
import palette from '@assets/theme/palette';
import CloseIcon from '@components/icons/Close';
import BreadCrumbsHOC, { BreadCrumbProps } from '@components/UI/breadcrumbs';
import CardWrapper from '@components/UI/CardWrapper';
import useMyRouting from '@context/useMyRouting/useMyRouting';
import Typography from '@mui/material/Typography';
import useDelivery from '@pages/AdditionalServices/tabs/DeliveryForm/useDelivery';
import { CALUCLATOR_LINK_BY_LANG_ID } from '@settings/localization/consts';
import React from 'react';

import { CartEmptyComponentStyledContainer } from './StyledComponent';

interface EmptyBasketPlaceholderProps {
  breadCrumbs: BreadCrumbProps[];
  titleText: string;
  subTitleText: string;
  infoText: string;
  calculatorBtnText: string;
}

function EmptyBasketPlaceholder({
  breadCrumbs,
  titleText,
  subTitleText,
  infoText,
  calculatorBtnText,
}: EmptyBasketPlaceholderProps) {
  const { setPage } = useMyRouting().actions;
  const [settings] = useDelivery().useSettings().useState();

  const { primaryLanguageId } = settings;

  const link = CALUCLATOR_LINK_BY_LANG_ID[primaryLanguageId] || CALUCLATOR_LINK_BY_LANG_ID.default;

  const goToCalculator = () => {
    window.open(link, '_self');
    setPage('widget');
  };

  return (
    <CartEmptyComponentStyledContainer component={'section'}>
      <CardWrapper className="services">
        <BreadCrumbsHOC crumbs={breadCrumbs} />
        <Typography variant={'h1'} color={'common.black'} className={'title'}>
          {titleText}
        </Typography>
        <Typography variant={'h2'} color={'common.black'} className={'section-title'}>
          {subTitleText}
        </Typography>
        <Typography variant={'body1'} color={'common.black'} className={'section-info'}>
          {infoText}
        </Typography>
        <MButton
          className={'calculation-link'}
          onClick={goToCalculator}
          fullWidth={true}
          variant={'outlined'}
          startIcon={<CloseIcon />}
          size={'large'}
          color={'inherit'}
          sx={{
            color: palette.light.blue[400],
            fontSize: 16,
            fontWeight: 600,
          }}
        >
          <span>{calculatorBtnText}</span>
        </MButton>
      </CardWrapper>
    </CartEmptyComponentStyledContainer>
  );
}

export { EmptyBasketPlaceholder };
